import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=22ea0246"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports